import React, { useEffect, useMemo, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { createImageUrl } from '../../../../../../../helper/Converters';
import { translate } from '../../../../../../../utils/language';

const ProductDetail_1 = ({ item }) => {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const shareIconFilter = useMemo(
    () => HexToHueConverter(customization?.shareIconColor),
    [customization?.shareIconColor],
  );
  const heartIconFilter = useMemo(
    () => HexToHueConverter(customization?.heartIconColor),
    [customization?.heartIconColor],
  );
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  const rating = 4;
  const totalStars = 5;
  const text = staticComponentValueConverter(item?.data?.text);
  const emptyTextSizes = ['S', 'M', 'L', 'XL'];
  const emptyColors = ['black', 'yellow', 'blue', 'green'];
  console.log(item)
  const VariantColors = ({ customization, staticValues, image, index, isColor, text, isActive }) => {
    return (
      <div className="flex flex-col">
        <div
          className="overflow-hidden"
          style={
            isActive
              ? {
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,
                borderWidth: staticValues[2],
                borderColor: customization?.colorVariant_SelectedVariantBorderColor,
                color: customization?.colorVariant_VariantColorTextColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
                flexShrink: 0,
                padding: customization?.colorVariant_BoxesPadding,
              }
              : {
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,
                borderWidth: staticValues[2],
                color: customization?.colorVariant_VariantColorTextColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
                flexShrink: 0,
                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                padding: customization?.colorVariant_BoxesPadding,
              }
          }
        >
          {customization?.colorVariant_ImageType === 'text' ? (
            <div
              className="flex w-full h-full justify-center items-center break-words "
              style={{
                color: isActive
                  ? customization?.colorVariant_SelectedTextColor
                  : customization?.colorVariant_DefaultTextColor,
                backgroundColor: isActive
                  ? customization?.colorVariant_SelectedTextBackgroundColor
                  : customization?.colorVariant_DefaultTextBackgroundColor,
              }}
            >
              {text || translate('exampleVariant')}
            </div>
          ) : isColor ? (
            <div className="w-full h-full" style={{ background: image }}></div>
          ) : (
            <img
              src={image || process.env.REACT_APP_DEFAULT_IMAGE}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          )}
        </div>
        {customization?.colorVariant_ShowVariantTitle === 'show' && (
          <div
            className="overflow-hidden truncate"
            style={{
              fontSize: customization?.colorVariant_VariantTitleTextSize,
              fontWeight: customization?.colorVariant_VariantTitleTextWeight,
              color: customization?.colorVariant_VariantTitleTextColor,
              textAlign: customization?.colorVariant_VariantTitleTextAlignment,
              fontStyle: customization?.colorVariant_VariantTitleTextStyle,
              width: customization?.colorVariant_BoxesWidth,
            }}
          >
            {text || translate('exampleVariant')}
          </div>
        )}
      </div>
    );
  };

  const VariantTexts = ({ customization, staticValues, text, isActive }) => {
    return (
      <div className="flex flex-col">
        <div
          className="overflow-hidden word-break truncate"
          style={{
            padding: customization?.textVariant_BoxesPadding,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderWidth: 1,
            borderColor: isActive
              ? customization?.textVariant_SelectedVariantBorderColor
              : customization?.textVariant_DefaultVariantBorderColor,
            borderRadius: customization?.textVariant_BoxesBorderRadius,
            backgroundColor: isActive
              ? customization?.textVariant_SelectedVariantBackgroundColor
              : customization?.textVariant_DefaultVariantBackgroundColor,
            width: customization?.textVariant_BoxesWidth,
            height: customization?.textVariant_BoxesHeight,
            fontSize: staticValues[12],
            color: isActive
              ? customization?.textVariant_SelectedVariantTextColor
              : customization?.textVariant_DefaultVariantTextColor,
            flexShrink: 0,
          }}
        >
          {text || translate('exampleVariant')}
        </div>
      </div>
    );
  };

  const [hashMap, setHashMap] = useState({});
  const productVariantTypes = firstProduct?.productVariantTypes;
  const firsVariantHash = productVariantTypes
    ?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return variantTypeId + variantValueIds?.[0];
    })
    ?.join(';');
  const iscolorVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'COLOR');
  const istextVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'CHOICE');
  console.log(iscolorVariant_Exists);
  useEffect(() => {
    const variantTypeValueArray = firstProduct?.productVariantTypes?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return { variantTypeId, variantValueIds };
    });

    const objectMap = {};
    firstProduct?.variants?.map(variant => {
      const keyArr = [];
      const variantValues = variant?.variantValues;
      variantValues?.map(v => {
        const variantTypeId = v?.variantTypeId;
        const variantValueId = v?.variantValueId;
        const typeIndex = variantTypeValueArray?.findIndex(
          variantTypeValue => variantTypeValue?.variantTypeId === variantTypeId,
        );
        if (typeIndex !== -1) {
          keyArr[typeIndex] = variantTypeId + variantValueId;
        }
      });
      const key = keyArr?.join(';');
      objectMap[key] = variant;
    });
    setHashMap(objectMap);
  }, []);

  return (
    <div>
      <div>
        <img
          width={'100%'}
          style={{ height: customization?.productImageHeight, objectFit: customization?.backgroundSize }}
          src={image || process.env.REACT_APP_DEFAULT_IMAGE}
          alt=""
        />
        <div className="border-b-1 border-stone-300 mx-3">
          {customization?.showBrandName === 'show' && (
            <div
              className="flex flex-row justify-between align-center "
              style={{
                fontSize: customization?.brandNameTextSize,
                color: customization?.brandNameTextColor,
                fontStyle: customization?.brandNameTextStyle,
                fontWeight: customization?.brandNameTextWeight,
                paddingTop: staticValues[10],
              }}
            >
              {firstProduct?.brand?.name || 'Ürün Markası'}
            </div>
          )}
          <div
            className={`${customization?.showBrandName === 'show'
              ? 'flex flex-row justify-between align-center'
              : 'flex flex-row justify-between align-center + pt-2.5'
              }`}
          >
            <div
              style={{
                textAlign: 'left',
                fontSize: customization?.imageTextSize,
                color: customization?.imageTextColor,
                fontStyle: customization?.imageTextStyle,
                fontWeight: customization?.imageTextWeight,
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: firstProduct?.name || 'Ürün Başlığı' }}></div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, gap: 5 }}>
              {customization?.isHeartIcon && (
                <div
                  className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                  style={{
                    backgroundColor: customization?.heartIconBackgroundColor,
                    borderRadius: customization?.heartIconBorderRadius,
                  }}
                >
                  <img
                    className="shrink-0"
                    src={customization?.heartIcon}
                    alt=""
                    style={{ filter: heartIconFilter, width: customization?.heartIconWidth }}
                  />
                </div>
              )}
              {customization?.isShareIcon && (
                <div
                  className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                  style={{
                    backgroundColor: customization?.shareIconBackgroundColor,
                    borderRadius: customization?.shareIconBorderRadius,
                  }}
                >
                  <img
                    className="shrink-0"
                    src={customization?.shareIcon}
                    alt=""
                    style={{ filter: shareIconFilter, width: customization?.shareIconWidth }}
                  />
                </div>
              )}
            </div>
          </div>
          {customization?.isShowStar === 'show' && (
            <div style={{ display: 'flex', gap: '5px' }}>
              {[...Array(totalStars)].map((item, index) => {
                const starIndex = index + 1;

                return (
                  <span
                    key={starIndex}
                    style={{
                      cursor: 'pointer',
                      color: starIndex <= rating ? '#FFD700' : '#ccc',
                      fontSize: customization?.starSize,
                    }}
                  >
                    &#9733;
                  </span>
                );
              })}
            </div>
          )}

          <div
            className="flex flex-row justify-between align-center "
            style={{
              display: customization?.showBarcode,
              fontSize: customization?.barcodeTextSize,
              color: customization?.barcodeTextColor,
              fontStyle: customization?.barcodeTextStyle,
              fontWeight: customization?.barcodeTextWeight,
            }}
          >
            Ürün Barkodu: {firstProduct?.variants?.[0]?.barcodeList?.[0] || '9003579308936'}
          </div>
          {customization?.isShowTag === 'show' && (
            <div className="flex flex-row gap-2">
              {firstProduct?.tags?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    backgroundColor: customization?.tagBackgroundColor,
                    width: 'fit-content',
                    borderRadius: customization?.tagBorderRadius,
                    padding: customization?.tagBoxPadding,
                    marginTop: '10px',

                    marginBottom: '10px',
                  }}
                >
                  <div>
                    <svg
                      fill={customization?.tagIconColor}
                      width={customization?.tagIconSize}
                      height={customization?.tagIconSize}
                      viewBox="0 0 30.72 30.72"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m30.719 12.488 0 -10.151c0 -1.288 -1.048 -2.337 -2.336 -2.337H18.022c-0.65 0 -1.635 0 -2.278 0.643L0.566 15.822c-0.365 0.365 -0.566 0.849 -0.566 1.365 0 0.516 0.201 1.001 0.565 1.366l11.604 11.602C12.533 30.519 13.017 30.72 13.533 30.72s1.001 -0.201 1.365 -0.565l15.179 -15.179c0.651 -0.649 0.647 -1.584 0.643 -2.487zm-2.001 1.13L13.526 28.796 1.924 17.18 17.086 2.015c0.153 -0.095 0.702 -0.095 0.93 -0.095l0.432 0.001 9.936 -0.001c0.23 0 0.416 0.187 0.416 0.417V12.496c0.002 0.365 0.004 0.976 -0.081 1.122M23.04 3.84c-2.121 0 -3.84 1.719 -3.84 3.84s1.719 3.84 3.84 3.84 3.84 -1.719 3.84 -3.84 -1.719 -3.84 -3.84 -3.84m0 5.76c-1.06 0 -1.92 -0.86 -1.92 -1.92s0.86 -1.92 1.92 -1.92 1.92 0.86 1.92 1.92 -0.86 1.92 -1.92 1.92" />
                    </svg>
                  </div>
                  <div
                    style={{
                      fontSize: customization?.tagTextSize,
                      color: customization?.tagTextColor,
                      fontStyle: customization?.tagTextStyle,
                      fontWeight: customization?.tagTextWeight,
                    }}
                  >
                    {item?.name}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div
        className=" "
        style={{
          marginRight: staticValues[10],
          marginLeft: staticValues[10],
          paddingTop: staticValues[10],
          paddingBottom: staticValues[10],
        }}
      >
        {firstProduct?.productVariantTypes?.map((type, typeIndex) => {
          const selectionType = type?.variantType?.selectionType;
          const values = type?.variantType?.values;
          const valuesLength = values?.length;
          const minLength = 4 - valuesLength;
          const defaultValuesArray = minLength > 0 ? Array.from({ length: minLength }) : [];
          console.log(defaultValuesArray);
          return (
            <>
              {selectionType === 'COLOR' ? (
                <div className="flex flex-col">
                  {item?.data?.colorVariant_TitleText && (
                    <div
                      style={{
                        fontSize: customization?.colorVariant_TitleTextSize,
                        fontWeight: customization?.colorVariant_TitleTextWeight,
                        color: customization?.colorVariant_TitleTextColor,
                        textAlign: customization?.colorVariant_TitleTextAlignment,
                        fontStyle: customization?.colorVariant_TitleTextStyle,
                      }}
                    >
                      {item?.data?.colorVariant_TitleText}
                    </div>
                  )}
                  <div
                    className="flex flex-row  align-center  "
                    style={
                      customization?.colorVariant_DisplayMode === 'slide'
                        ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                        : { flexWrap: 'wrap', gap: 20 }
                    }
                  >
                    {type?.variantType?.values?.map((value, valueIndex) => {
                      let firsVariantHashArray = firsVariantHash?.split(';');
                      firsVariantHashArray[typeIndex] = type?.variantType?.id + value?.id;

                      const variant = hashMap[firsVariantHashArray?.join(';')];
                      if (!variant) return <></>;

                      if (customization?.colorVariant_ImageType === 'image') {
                        const image = createImageUrl(variant?.images?.[0]?.id);

                        return (
                          <VariantColors
                            staticValues={staticValues}
                            isActive={variant?.id === firstProduct?.variants?.[0]?.id}
                            customization={customization}
                            image={image}
                            index={valueIndex}
                          />
                        );
                      } else {
                        const image = value?.thumbnailImageId
                          ? createImageUrl(value?.thumbnailImageId)
                          : value?.colorCode;

                        return (
                          <VariantColors
                            staticValues={staticValues}
                            isActive={variant?.id === firstProduct?.variants?.[0]?.id}
                            customization={customization}
                            text={value?.name}
                            isColor={!value?.thumbnailImageId}
                            image={image}
                            index={valueIndex}
                          />
                        );
                      }
                    })}

                    {customization?.colorVariant_ImageType === 'image' &&
                      defaultValuesArray?.map((arr, index) => {
                        return <VariantColors staticValues={staticValues} customization={customization} image={null} />;
                      })}

                    {customization?.colorVariant_ImageType !== 'image' &&
                      defaultValuesArray?.map((arr, index) => {
                        return (
                          <VariantColors
                            staticValues={staticValues}
                            customization={customization}
                            isColor={true}
                            image={emptyColors[index]}
                          />
                        );
                      })}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col">
                  <div
                    style={{
                      fontSize: customization?.textVariant_TitleTextSize,
                      fontWeight: customization?.textVariant_TitleTextWeight,
                      color: customization?.textVariant_TitleTextColor,
                      textAlign: customization?.textVariant_TitleTextAlignment,
                      fontStyle: customization?.textVariant_TitleTextStyle,
                    }}
                  >
                    {item?.data?.textVariant_TitleText}
                  </div>
                  <div
                    className="flex flex-row  align-center  "
                    style={
                      customization?.textVariant_DisplayMode === 'slide'
                        ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                        : { flexWrap: 'wrap', gap: 20 }
                    }
                  >
                    {type?.variantType?.values?.map((value, valueIndex) => {
                      let firsVariantHashArray = firsVariantHash?.split(';');
                      firsVariantHashArray[typeIndex] = type?.variantType?.id + value?.id;

                      const variant = hashMap[firsVariantHashArray?.join(';')];
                      if (!variant) return <></>;
                      return (
                        <VariantTexts
                          isActive={
                            variant?.id === firstProduct?.variants?.[0]?.id || (typeIndex !== 0 && valueIndex === 0)
                          }
                          customization={customization}
                          text={value?.name}
                          staticValues={staticValues}
                        />
                      );
                    })}
                    {defaultValuesArray?.map((arr, index) => {
                      return <VariantTexts isActive={true} customization={customization} staticValues={staticValues} />;
                    })}
                  </div>
                </div>
              )}
            </>
          );
        })}

        {!iscolorVariant_Exists && (
          <div className="flex flex-col">
            {item?.data?.colorVariant_TitleText && (
              <div
                style={{
                  fontSize: customization?.colorVariant_TitleTextSize,
                  fontWeight: customization?.colorVariant_TitleTextWeight,
                  color: customization?.colorVariant_TitleTextColor,
                  textAlign: customization?.colorVariant_TitleTextAlignment,
                  fontStyle: customization?.colorVariant_TitleTextStyle,
                }}
              >
                {item?.data?.colorVariant_TitleText}
              </div>
            )}
            <div
              className="flex flex-row  align-center "
              style={
                customization?.colorVariant_DisplayMode === 'slide'
                  ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                  : { flexWrap: 'wrap', gap: 20 }
              }
            >
              {customization?.colorVariant_ImageType === 'image' && (
                <>
                  <VariantColors
                    staticValues={staticValues}
                    isActive={true}
                    customization={customization}
                    image={null}
                  />
                  <VariantColors staticValues={staticValues} customization={customization} image={null} />
                  <VariantColors staticValues={staticValues} customization={customization} image={null} />
                  <VariantColors staticValues={staticValues} customization={customization} image={null} />
                </>
              )}

              {customization?.colorVariant_ImageType !== 'image' && (
                <>
                  {emptyColors?.map((color, index) => {
                    <VariantColors
                      staticValues={staticValues}
                      isActive={index === 0}
                      customization={customization}
                      isColor={true}
                      image={color}
                    />;
                  })}
                </>
              )}
            </div>
          </div>
        )}
        {!istextVariant_Exists && (
          <div className="flex flex-col">
            <div
              style={{
                fontSize: customization?.textVariant_TitleTextSize,
                fontWeight: customization?.textVariant_TitleTextWeight,
                color: customization?.textVariant_TitleTextColor,
                textAlign: customization?.textVariant_TitleTextAlignment,
                fontStyle: customization?.textVariant_TitleTextStyle,
              }}
            >
              {item?.data?.textVariant_TitleText}
            </div>
            <div
              className="flex flex-row  align-center"
              style={
                customization?.textVariant_DisplayMode === 'slide'
                  ? { overflowX: 'auto', whiteSpace: 'nowrap', gap: 20 }
                  : { flexWrap: 'wrap', gap: 20 }
              }
            >
              <VariantTexts isActive={true} customization={customization} staticValues={staticValues} />
              <VariantTexts customization={customization} staticValues={staticValues} />
              <VariantTexts customization={customization} staticValues={staticValues} />
              <VariantTexts customization={customization} staticValues={staticValues} />
            </div>
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          textAlign: 'left',
          gap: 5,
        }}
        className="py-2.5 mx-3 "
      >
        {customization?.isShowDescriptionTitle === 'show' && (
          <div
            style={{
              fontSize: customization?.descriptionTitleTextSize,
              fontWeight: customization?.descriptionTitleTextWeight,
              color: customization?.descriptionTitleTextColor,
              textAlign: customization?.descriptionTitleTextAlignment,
              fontStyle: customization?.descriptionTitleTextStyle,
              marginBottom: 10,
              width: '100%',
            }}
          >
            {item?.data?.text}
          </div>
        )}
        {customization?.isShowProductTitle === 'show' && (
          <div
            style={{
              fontSize: customization?.ProductTitleTextSize,
              fontWeight: customization?.ProductTitleTextWeight,
              color: customization?.ProductTitleTextColor,

              fontStyle: customization?.ProductTitleTextStyle,
              marginBottom: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{ width: '100%', textAlign: customization?.ProductTitleTextAlignment }}
              dangerouslySetInnerHTML={{ __html: firstProduct?.description }}
            ></div>
          </div>
        )}

        <div dangerouslySetInnerHTML={{ __html: firstProduct?.description }}></div>
      </div>
    </div>
  );
};

export default ProductDetail_1;
